import { LegacyBox, LegacyText, styled } from '@gogame/components';

export const ErrorTitle = styled(LegacyText)`
  color: ${({ theme }) => theme.palette.error.main};
`;

export const ErrorBox = styled(LegacyBox)`
  padding: 0 0 16px;
`;

export const ErrorText = styled(LegacyText)`
  color: ${({ theme }) => theme.palette.error.main}
  font-size: 12px;
`;

export const ErrorPath = styled(LegacyText)`
  color: ${({ theme }) => theme.palette.error.main};
`;
